import HttpClient from '../../adapter/HttpClient';
import RootDomain, { IRootDomain } from '../../entity/RootDomain';
import SiteScript from '../../entity/SiteScript';
import SpeculationRule from '../../entity/SpeculationRule';
class JavaScriptCodeWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public getSiteScript = async (organizationId: string): Promise<SiteScript> => {
    const result = await this.httpClient.get(`/organizations/${organizationId}/site_script`);

    return SiteScript.fromJSON(result.data.data);
  };

  public getRootDomains = async (organizationId: string): Promise<RootDomain[]> => {
    const result = await this.httpClient.get(`/organizations/${organizationId}/root_domains`);

    return result.data.data.map((rootDomain: IRootDomain) => RootDomain.fromJSON(rootDomain));
  };

  public getSiteJsPermission = async (organizationId: string): Promise<boolean> => {
    const result = await this.httpClient.get(`/organizations/${organizationId}`);

    return result.data.data.permissions.create_site_js.permit;
  };

  public postRootDomain = async (organizationId: string, name: string): Promise<void> => {
    await this.httpClient.post(`/organizations/${organizationId}/root_domains`, {
      id: organizationId,
      root_domain: {
        $focus: false,
        $editable: true,
        name: name,
      },
    });
  };

  public putRootDomain = async (name: string, domain: RootDomain): Promise<void> => {
    await this.httpClient.put(`/root_domains/${domain.id}`, {
      id: domain.id,
      root_domain: {
        $focus: false,
        $editable: true,
        name: name,
        created_at: domain.createdAt,
        updated_at: domain.updatedAt,
        use_root_domain_cookie: domain.useRootDomainCookie,
      },
    });
  };

  public deleteRootDomain = async (domain: RootDomain): Promise<void> => {
    await this.httpClient.delete(`/root_domains/${domain.id}`);
  };

  public putSiteScript = async (organizationId: string, isEmpty: boolean): Promise<void> => {
    await this.httpClient.put(`/organizations/${organizationId}/site_script`, {
      id: organizationId,
      site_script: {
        is_empty: isEmpty,
      },
    }); 
  };

  public getSpeculationRule = async (organizationId: string): Promise<SpeculationRule> => {
    const result = await this.httpClient.get(`/organizations/${organizationId}/speculation_rule`);

    return SpeculationRule.fromAPI(result.data.data);
  };

  public putSpeculationRule = async (organizationId: string, speculationRule: SpeculationRule): Promise<SpeculationRule> => {
    const result = await this.httpClient.put(`/organizations/${organizationId}/speculation_rule`, { data: speculationRule.toAPI() });

    return SpeculationRule.fromAPI(result.data.data);
  };
}

export default JavaScriptCodeWebApi;
